import bmAdAstraLogoPng from './img/bmAdAstraLogo.png';
import bmAdAstraLogoWhitePng from './img/bmAdAstraLogoWhite.png';

export const bmAdAstraLogo = {
  alt: 'BM AdAstra logo',
  src: bmAdAstraLogoPng.src,
};

export const bmAdAstraLogoWhite = {
  alt: 'BM AdAstra logo',
  src: bmAdAstraLogoWhitePng.src,
};
